import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon_13.png'


const _withScopeId = n => (_pushScopeId("data-v-7f49a32f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wh-14",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = { class: "ml-8 fz-14 lh-32" }

import { ref, withDefaults, getCurrentInstance } from 'vue';
	import translate from '@/api/translate';

	interface main {
		data ?: any
	}

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ImportBtn',
  props: {
    data: { default: {} }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

	const props = __props;
	
	const { proxy } = getCurrentInstance() as any;
	const ImportFilePop = ref<any>();
	const emits = __emit

	const ShowImportFile = () => {
		if (!props.data.upapi) {
			proxy.$message.error("暂未开放");
			return false;
		}
		ImportFilePop.value.open({
			name: props.data.name,
			downapi: props.data.downapi,
			downname: props.data.downname,
			upapi: props.data.upapi,
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ImportFile = _resolveComponent("ImportFile")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "import-btn",
      plain: "",
      type: "primary",
      onClick: ShowImportFile
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(translate).ShowText('导入')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_ImportFile, {
      ref_key: "ImportFilePop",
      ref: ImportFilePop,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (emits('change')))
    }, null, 512)
  ]))
}
}

})